export enum ClerkActionType {
  click = 'click',
  scroll = 'scroll',
  show = 'show',
}

export enum ClerkCategoryType {
  goToDetail = 'go_to_detail',
}

export enum SourceType {
  personalSuggestionsBlock = 'personalSuggestionsBlock',
  personalTopSellerProductsBlock = 'business_sellers-index',
  personalNewArrivalsBlock = 'personalCollectionBlock',
  personalDayDiscountBlock = 'personalDayDiscountBlock',
}
